import React, {useEffect} from 'react';
import aboutImg from '../assets/images/aboutus.svg';
import Teams1 from './Teams';
import { Teams10DataSource } from './data.source';

import '../assets/styles/less/singlePage.less';
import './less/teams.less';


const AboutUs = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    });

    return (
        <div className="main">
            <div className="container">

                <div className="page-title">
                    <h1>درباره ما</h1>
                </div>
                <h5 className="page-subtitle">
                    مدتاک می کوشد تا با ایجاد بستری آنلاین و هوشمند در عین سادگی و صرفه جویی در وقت و هزینه، تحولی شگرف در مدیریت مراکز آموزشی، و مدارس پدید آورد به این امید که در راه آموزش و ارتقای سطح علمی فرزندان این سرزمین همراه و یاور مدارس باشد.
                </h5>

                <div className="page-img">
                    <img src={aboutImg} width="100%" alt="img" />
                </div>

                <section>
                    <Teams1
                        id="Teams1_0"
                        key="Teams1_0"
                        dataSource={Teams10DataSource}
                    />
                </section>
            </div>
        </div>
    )
}

export default AboutUs;